/**
 * 判断某个对象是某种类型
 * @see javascript秘密花园 http://bonsaiden.github.com/JavaScript-Garden/zh/#types
 * @param  {String}  type 对象类型Class Name
 * @param  {any}  obj  需要判断的Object
 * @return {boolean}      对象是否是某种类型
 */
export default function is(type, obj) {
    var klass = Object.prototype.toString.call(obj).slice(8, -1);
    return obj !== undefined && obj !== null && klass === type;
}
//# sourceMappingURL=is.js.map